<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="red" dark v-bind="attrs" v-on="on"  @click="getTransition">
        过渡费修改
      </v-btn>
    </template>
    <v-container class="px-3 my-container">
      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10">
          <h1>过渡费修改</h1>
        </v-card-title>
        <v-row style="height: 80px;">
            <v-text-field style="height: 80px;" v-model="transition.transition_user" color="yellow darken-3" label="姓名"></v-text-field>
        </v-row>
        <v-row style="height: 80px;">
          <v-text-field style="height: 80px;" v-model="transition.transition_first" color="yellow darken-3" label="第一次" required ></v-text-field>
        </v-row>
        <v-row  style="height: 80px;">
          <v-text-field style="height: 80px;" v-model="transition.transition_second" color="yellow darken-3" label="第二次" required ></v-text-field>
        </v-row>
        <v-row  style="height: 80px;">
          <v-text-field v-model="transition.transition_third" color="yellow darken-3" label="第三次" required ></v-text-field>
        </v-row>
        <v-row style="height: 80px;">
          <v-text-field style="height: 80px;" v-model="transition.transition_issued" color="yellow darken-3" label="总计" required ></v-text-field>
        </v-row>
        <v-row style="height: 80px;">
          <v-text-field style="height: 80px;" v-model="transition.transition_total_fee" color="yellow darken-3" label="总过渡费" required ></v-text-field>
        </v-row>
        <v-row  style="height: 80px;">
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelAddDialog">取消</v-btn>
          <v-btn color="primary" @click="updateCustomer">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
</template>

<script>
import { getCustomerTransition, PutCustomerTransition } from "@/api/customers";
import { recordLog } from "@/utils/log";
export default {
  name: "UpdateTransitionDialog",
  components: {},
  data: () => ({
    rules: {
      required: value => !!value || 'Field is required',
    },
    objectItem: {},
    stringItem: "",
    dialog: false,
    customer: {},
    originalTransition: {},
    transition: {
      transition_first:0,
      transition_second:0,
      transition_third: 0,
      transition_issued:0,  //总计
      // transition_fee: 0// 总过渡费
      transition_total_fee:0
    },
    alert: false,
    alert_text: "",
  }),
  watch: {
    'dialog': {
      handler(newVal) {
        // console.log(this.$parent.customer, 111)
        this.customer = this.$parent.customer;
      },
      deep: true
    }
  },
  methods: {
    getTransition() {
      getCustomerTransition(this.$parent.customer.id).then(res => {
       this.transition.transition_user = res.data.transition_user;
       this.transition.transition_first = res.data.transition_first;
       this.transition.transition_second = res.data.transition_second;
       this.transition.transition_third = res.data.transition_third;
       this.transition.transition_issued = res.data.transition_issued;  //总计
       this.transition.transition_total_fee = this.$parent.customer.transition ? this.$parent.customer.transition.transition_total : 0;
       // 保存原始值用于对比
       this.originalTransition = {
         transition_user: this.transition.transition_user,
         transition_first: this.transition.transition_first,
         transition_second: this.transition.transition_second,
         transition_third: this.transition.transition_third,
         transition_issued: this.transition.transition_issued,
         transition_total_fee: this.transition.transition_total_fee
       };
      })
    },
    updateCustomer() {
      const customersData = this.transition;
      customersData.customer_id = this.$parent.customer.id;
      PutCustomerTransition(customersData).then(response => {
        this.dialog = false;
        this.$parent.getTransition(customersData.customer_id);
        // 对比变更并记录日志
        const changes = [];
        const fields = [
          { key: 'transition_user', label: '姓名' },
          { key: 'transition_first', label: '第一次' },
          { key: 'transition_second', label: '第二次' },
          { key: 'transition_third', label: '第三次' },
          { key: 'transition_issued', label: '总计' },
          { key: 'transition_total_fee', label: '总过渡费' }
        ];
        fields.forEach(f => {
          const oldVal = this.originalTransition[f.key];
          const newVal = this.transition[f.key];
          if (String(oldVal) !== String(newVal)) {
            changes.push(`${f.label}: ${oldVal} → ${newVal}`);
          }
        });
        if (changes.length > 0) {
          recordLog({
            event: '过渡费修改',
            customername: this.$parent.customer.customer || this.$parent.customer.name || '',
            api: '/customers/transition',
            details: changes.join('；')
          });
        }
      });
    },

    cancelAddDialog() {
      this.dialog = false;
      this.transition.transition_user = '';
       this.transition.transition_first = '';
       this.transition.transition_second = '';
       this.transition.transition_third = '';
       this.transition.transition_issued = '';  //总计
       this.transition.transition_total_fee = 0;
    }
  }
};
</script>

<style scoped>
.my-container {
  background-color: rgba(90, 90, 90, 0.9);
}
</style>